import groupBy from "lodash/fp/groupBy";

class Controller {
  constructor(Events, RescueReasons) {
    "ngInject";

    this.Events = Events;
    this.RescueReasons = RescueReasons;

    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.loading = true;
    this.RescueReasons.getAll({ active: true, city: this.city })
      .$promise.then(
        (response) => {
          this.rescueReasons = groupBy("category")(response.hits);
        },
        (response) => {
          this.Events.emit(this.errorNotificationEvent, response.data);
        }
      )
      .finally(() => {
        this.loading = false;
      });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/rescueReasons/rescueReasons.controller.js